module.exports = __webpack_public_path__ + "images/smartphone-screen-3_69e8934774ca2d3079e2f4fbfb7b75fe.png";